import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomizeFormModule } from 'src/app/shared/components/customize-form/customize-form.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { PageNotFoundComponent } from './page-not-found.component';
@NgModule({
  imports: [CommonModule, PipesModule, CustomizeFormModule],
  declarations: [PageNotFoundComponent],
  exports: [PageNotFoundComponent],
})
export class PageNotFoundModule {}
